import { i18n } from '@/plugins/i18n'
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, type Locale, isLocale } from '@/router/locales'

export function normalizeLocale(input: unknown): string {
  if (typeof input === 'string') return input
  if (typeof input === 'object' && input !== null && 'value' in input) {
    return String(input.value)
  }
  return String(input)
}

export function getFallbackLocale(): Locale {
  const fallbackLocale = normalizeLocale(i18n.global.fallbackLocale)
  return isLocale(fallbackLocale) ? fallbackLocale : DEFAULT_LOCALE
}

export { SUPPORTED_LOCALES, isLocale }
export type { Locale }
